export default {
  EN_US: "en-US",
  ZH_HK: "zh-HK",
  ZH_CN: "zh-CN",
}
